import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  ApiResponsePagination,
  ApiResponsePaginationNoTotal,
  BackendApiResponse,
  PaginableItemsList,
} from '@shared/core/types';

export function convertApiResponseToPaginable<T>(
  backendResponse: Observable<BackendApiResponse<T>>,
): Observable<PaginableItemsList<T>> {
  return backendResponse.pipe(
    map(
      (response: BackendApiResponse<T>): PaginableItemsList<T> => ({
        data: response.data,
        pagination: response.pagination as ApiResponsePagination,
      }),
    ),
    catchError(() =>
      of({
        data: [] as any,
        pagination: {
          total: 0,
          pages: 0,
          currentPage: 0,
          pageSize: 0,
        },
      }),
    ),
  );
}

export function convertApiItemResponseToItem<T>(backendResponse: Observable<BackendApiResponse<T>>): Observable<T> {
  return backendResponse.pipe(map(response => response.data));
}

export function convertApiResponseToNoTotalPaginable<T>(
  backendResponse: Observable<BackendApiResponse<T>>,
): Observable<PaginableItemsList<T>> {
  return backendResponse.pipe(
    map((response: BackendApiResponse<T>): PaginableItemsList<T> => {
      const pagination = response.pagination as ApiResponsePaginationNoTotal;
      const pages = pagination.hasNextPage ? pagination.currentPage + 1 : pagination.currentPage;
      const total = pagination.hasNextPage
        ? pagination.pageSize * pages + pagination.pageSize // one more page
        : pagination.pageSize * pagination.currentPage;

      return {
        data: response.data,
        pagination: {
          total,
          pages,
          currentPage: pagination.currentPage,
          pageSize: pagination.pageSize,
        },
      };
    }),
    catchError(() =>
      of({
        data: [] as any,
        pagination: {
          total: 0,
          pages: 0,
          currentPage: 0,
          pageSize: 0,
        },
      }),
    ),
  );
}
